/* global Symbol */
import React, { PropTypes } from 'react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import FlatButton from '../../../../../../common/components/c_FlatButton';
import ProgressComponent from '../../../../../../common/components/C_ProgressComponent';
import _ from 'lodash';
import * as applicationStatus from '../../../../../applicant/helpers/status';

const dropdownStyling = {
  containerStyle: {
    width: '95%',
    transform: 'translateY(-2px)'
  },
  labelStyle: {
    padding: 0
  },
  listStyle: {
    width: '100px'
  },
  menuStyle: {
    width: '100px'
  },
  iconStyle: {
    right: 0
  },
  underlineStyle: {
    display: 'none'
  }
};

export default class SummaryOfSkills extends ProgressComponent {
  static propTypes = {
    user: PropTypes.object,
    profile: PropTypes.object,
    profileId: PropTypes.number.isRequired,
    skills: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    model: PropTypes.string.isRequired,
    updateTempState: PropTypes.func.isRequired,
    validation: PropTypes.object.isRequired,
    title: PropTypes.string,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {};
    this.state.skills = _.merge({}, props.skills, props.tempState.skills || {});
    this.state.validation = {};
  }

  componentWillReceiveProps(nextProps) {
    const newSkills = _.merge({}, this.state.skills, nextProps.skills, nextProps.tempState.skills);
    this.setState({
      skills: newSkills
    });
  }

  validateForm() {
    const validation = _.merge({}, this.state.validation);
    const skills = _.get(this.state, 'skills', {});

    const formValid = _.reduce(skills, (catValid, cat) => {
      return _.reduce(cat, (skillValid, skill, name) => {

        const isValid = _.isNil(skill) || skill.deleted || name === 'None' ||  !_.isNil(skill.lastUsed) &&
          !_.isNil(skill.yearsOfExperience) && !_.isNil(skill.skillLevel);
        validation[name] = !isValid || null;
        return isValid && skillValid;

      }, true) && catValid;
    }, true);

    this.setState(_.merge({}, this.state, {validation}));
    return formValid;
  }

  onChange(target, prop, event, value) {
    const updatedSkill = _.merge({}, this.state.skills[target.categoryId][target.name]);
    updatedSkill[prop] = value;
    if(_.get(this.props.tempState, this.props.model)) {
      this.props.updateTempState(`${this.props.model}`, `${target.categoryId}.${target.name}`, null, updatedSkill);
    }
    else {
      this.props.updateTempState(`${this.props.model}`, '', null, {});
      setTimeout(() => {
        this.props.updateTempState(`${this.props.model}`, `${target.categoryId}.${target.name}`, null, updatedSkill);
      });
    }
  }

  onDelete(target, event) {
    this.onChange(target, 'deleted', event, Symbol.for('_deleted_'));
  }

  mapSummary(skills) {
    return _.reduce(skills, (accumulator, category) =>
      accumulator.concat(_.map(category, val => val)), []
    );
  }

  render() {
    const errorMessage = 'Please fill out all fields.';
    const state =_.merge({}, this.state.skills, this.props.tempState.skills);
    const skills = _.sortBy(_.filter(_.reduce(state, (accumulator, category) => accumulator.concat(_.map(category, val => val)), []), s => !s.deleted), ['categoryId', 'name']);
    let lastUsedOpts = _.map(_.times(11), (val) => ({value:(val ? val : 100), primaryText:(val ? (val > 1 ? `${val} Years Ago` : `${val} Year Ago`) : 'Current')}));
      lastUsedOpts.push({ primaryText : '10+ Years Ago', value: 11 });
    const yearsOfExpOpts = _.map(_.times(10).concat(_.range(10, 60, 10)), (val) => ({value:val, primaryText:val}));
    const expertiesOpts = _.map(this.props.staticData.skillLevelTypes, (item) => ({value:item.id, primaryText:item.name}));
    const requiredSkillCategories = this.props.staticData.skillCategoryTypes.filter((cat) => !cat.hasNone).map((cat) => cat.id);

    // required categories that should be removable
    const filteredRequiredSkillCategories = [];

    // collect the required categories that have only one skill selected
    // this ensures that you can't remove the last skill in a required category on this screen
    requiredSkillCategories.forEach(cat =>
    {
      if (skills.filter(skill => skill.categoryId === cat).length === 1) {
        filteredRequiredSkillCategories.push(cat);
      }
    });

		// Filtering out skills with none selection
		for (let i = skills.length -1; i >= 0; i--) {
      if (skills[i].name === 'None') {
        skills.splice(i, 1);
      }
     }

    const errorLabel = <div className='error-message'>{errorMessage}</div>;
    const isQualified = applicationStatus.isQualified(_.get(this.props.profile, 'applicantStatus'));

    return (
      <div className='application-section-container clearfix skills'>
          {
            this.props.adminView
            &&
            <div className='expanded-accordion-content explanation-of-wahve'>
            {
              (this.props.script)
              &&
              <div className='speaking-callout'>
                Script: Let’s now review your skills.
              </div>
            }
              <div className='callout'>
                <b>Instructions:</b>
              </div>
              <div className='callout'>
                Review the Summary of Skills table with the applicant. Confirm the
                skills selected, skills levels, and last used. This is important as
                some applicants are not familiar with the labels we give to some
                skills. If any are incorrect, update the skill and the table. It is
                essential that the Skills Table is accurate as it is the basis of
                successfully matching applicants to Job Requests.
              </div>
              <div className='callout'>
                In notes, provide a commentary about the applicant’s skills and types
                of positions applicant may be qualified for.
              </div>
            </div>
        }

        {
          !(this.props.adminView || this.props.submitted)
          &&
          <div className='applicant-instructions'>
            <div className='callout'>
            Please complete the following table for the professional skills you selected. For each skill, select the skill level, years of experience, and when you last used the skill. Please note, all fields are required for each skill selected. To add a skill to the Table, you must go back to the skill Category and select the skill you wish to add.
            </div>
          </div>
        }

        {
          isQualified &&
          <div className='application-section-container'>
            <div className='form-heading'>Summary of Skills</div>
            <div className='form-text'>If you added skills to your profile, for each skill added, you must select the skill level, years of experience, and when you last used the skill. Make sure you click on SAVE before you sign out.</div>
          </div>
        }

        {skills.length === 0 ? <span className='no-skills'>No Skills have been selected</span> : null}
        {!(skills.length === 0) ?
          <div className='application-section-table-container clearfix'>

          <div className='summary-skills-table'>
            <Table
              selectable={false}
              multiSelectable={false}
              fixedHeader
              wrapperStyle={{overflow: 'visible'}}
              headerStyle={{position: 'sticky', top: '-30px', zIndex: '1'}}
              className='mui-table-summary'
            >
              <TableHeader
                displaySelectAll={false}
                adjustForCheckbox={false}
              >
                <TableRow>
                  <TableHeaderColumn className='category' style={{color: '#4a4a4a', fontSize: '14px'}}>Category</TableHeaderColumn>
                  <TableHeaderColumn className='name' style={{color: '#4a4a4a', fontSize: '14px'}}>Skill Name</TableHeaderColumn>
                  <TableHeaderColumn className='last-used' style={{width: '160px', color: '#4a4a4a', fontSize: '14px'}}>Skill Last Used</TableHeaderColumn>
                  <TableHeaderColumn className='yrs' style={{width: '60px', color: '#4a4a4a', fontSize: '14px'}}>Yrs. of Exp.</TableHeaderColumn>
                  <TableHeaderColumn className='level' style={{width: '130px', color: '#4a4a4a', fontSize: '14px'}}>Skill Level</TableHeaderColumn>
                  <TableHeaderColumn className='actions'/>
                </TableRow>
              </TableHeader>
              <TableBody
                displayRowCheckbox={false}
              >
                {
                  skills.map((row, index) =>
                    <TableRow key={`${row.categoryId}-${row.name}`}>
                      <TableRowColumn data-id={`Category${index}`} className='category'>{
                        this.props.staticData.skillCategoryTypes.find((elem) => {
                          return elem.id === row.categoryId;
                        }).name || ''
                      }</TableRowColumn>
                      <TableRowColumn style={{width: '280px'}} data-id={`SkillName${index}`} className='name'>
                        {row.name}
                        {!_.isNil(this.state.validation[row.name]) && errorLabel}
                      </TableRowColumn>
                      <TableRowColumn style={{paddingLeft:'2px', paddingRight:'0px', width: '160px'}} className='last-used'>
                        <DropDownMenu
                          data-id={`LastUsed${index}`}
                          canAutoPosition='true'
                          defaultValue={row.lastUsed}
                          menuItems={lastUsedOpts}
                          onChange={this.onChange.bind(this, row, 'lastUsed')}
                          validation={this.props.validation.lastUsed}
                          onErrorChange={this.props.errorUpdate}
                          errorText={_.get(this.state.validation, `${row.categoryId}.${row.name}`)}
                          {...dropdownStyling}
                        />
                      </TableRowColumn>
                      <TableRowColumn style={{paddingLeft:'2px', paddingRight:'0px', width: '60px'}} className='yrs'>
                        <DropDownMenu
                          data-id={`YearsOfExperience${index}`}
                          canAutoPosition='true'
                          defaultValue={row.yearsOfExperience}
                          menuItems={yearsOfExpOpts}
                          onChange={this.onChange.bind(this, row, 'yearsOfExperience')}
                          validation={this.props.validation.yearsOfExperience}
                          onErrorChange={this.props.errorUpdate}
                          {...dropdownStyling}
                        />
                      </TableRowColumn>
                      <TableRowColumn style={{paddingLeft:'2px', paddingRight:'0px', width: '130px'}} className='level'>
                        <DropDownMenu
                          data-id={`SkillLevel${index}`}
                          canAutoPosition='true'
                          defaultValue={row.skillLevel}
                          menuItems={expertiesOpts}
                          onChange={this.onChange.bind(this, row, 'skillLevel')}
                          validation={this.props.validation.skillLevel}
                          onErrorChange={this.props.errorUpdate}
                          {...dropdownStyling}
                        />
                      </TableRowColumn>
                      <TableRowColumn className='actions'>
                        {
                          (!filteredRequiredSkillCategories.includes(row.categoryId))
                          &&
                          <FlatButton
                            data-id={`Remove${index}`}
                            label='Remove'
                            data-id={`Remove${index}`}
                            onClick={this.onDelete.bind(this, row)}
                          />
                        }
                      </TableRowColumn>
                    </TableRow>
                  )
                }
              </TableBody>
            </Table>
          </div>
        </div>
: null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Skills/c_SummaryOfSkills/index.js